var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 120,
    viewBox: "0 0 200 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.12687 104.55V117.725H11.5965V119.486H0.126587V104.55H2.12687Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0523 104.55V114.18C30.0523 117.816 27.224 119.874 23.4336 119.874C19.6863 119.874 16.8606 117.816 16.8606 114.18V104.55H18.8381V114.18C18.8381 116.719 20.8611 118.113 23.4362 118.113C26.0568 118.113 28.0545 116.717 28.0545 114.18V104.55H30.0523Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7009 116.901C50.0677 118.503 47.5864 119.874 44.5075 119.874C39.6587 119.874 36.2557 116.352 36.2557 112.005C36.2557 107.707 39.6561 104.162 44.4138 104.162C47.1028 104.162 49.6322 105.19 51.2856 106.724L49.9285 108.052C48.5485 106.749 46.4343 105.925 44.4593 105.925C40.874 105.925 38.3446 108.692 38.3446 112.033C38.3446 115.394 40.8968 118.118 44.5277 118.118C46.9179 118.118 48.9866 117.019 50.3665 115.601L51.7009 116.901Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8453 104.55L64.8698 110.244L72.1088 119.484H69.5337L63.4215 111.569L59.8134 115.069V119.484H57.8131V104.547H59.8134V112.849L68.3867 104.547H70.8453V104.55Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.577 104.55L83.4167 112.487V119.486H81.4164V112.487L75.256 104.55H77.783L82.495 110.725L87.2299 104.55H89.577Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.927 107.913C113.593 106.679 111.479 105.923 109.595 105.923C106.032 105.923 103.435 108.667 103.435 112.03C103.435 115.233 105.825 118.115 109.777 118.115C111.547 118.115 113.479 117.566 114.626 116.651V113.106H109.755V111.345H116.442V117.611C114.626 119.007 112.051 119.877 109.661 119.877C104.949 119.877 101.341 116.354 101.341 112.008C101.341 107.661 104.972 104.164 109.57 104.164C111.937 104.164 114.373 105.056 116.305 106.679L114.927 107.913Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.66 119.486V104.55H131.935C133.867 104.55 135.199 105.076 136.14 106.059C136.875 106.838 137.29 107.843 137.29 108.987C137.29 111 135.91 112.577 133.796 113.149L137.498 119.484H135.221L131.773 113.399H125.658V119.484H123.66V119.486ZM125.661 106.311V111.64H132.441C134.097 111.64 135.315 110.428 135.315 108.964C135.315 108.301 135.039 107.684 134.604 107.226C133.869 106.495 132.97 106.311 131.937 106.311H125.661Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.082 104.162C155.725 104.162 159.448 107.661 159.448 111.983C159.448 116.374 155.723 119.874 151.082 119.874C146.415 119.874 142.762 116.374 142.762 111.983C142.759 107.661 146.415 104.162 151.082 104.162ZM151.082 118.113C154.599 118.113 157.356 115.369 157.356 111.983C157.356 108.644 154.599 105.923 151.082 105.923C147.565 105.923 144.853 108.644 144.853 111.983C144.853 115.369 147.565 118.113 151.082 118.113Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.845 104.55V114.18C178.845 117.816 176.017 119.874 172.227 119.874C168.479 119.874 165.653 117.816 165.653 114.18V104.55H167.631V114.18C167.631 116.719 169.654 118.113 172.229 118.113C174.85 118.113 176.847 116.717 176.847 114.18V104.55H178.845Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.406 119.486V104.55H194.518C196.473 104.55 197.782 105.076 198.724 106.059C199.483 106.883 199.873 107.888 199.873 108.941C199.873 110.176 199.367 111.252 198.542 112.028C197.645 112.897 196.382 113.401 194.518 113.401H188.406V119.486H186.406ZM188.406 106.311V111.64H194.521C195.372 111.64 196.313 111.524 197.096 110.793C197.602 110.312 197.901 109.649 197.901 108.964C197.901 108.301 197.648 107.729 197.189 107.226C196.478 106.47 195.513 106.311 194.523 106.311H188.406Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.102 0V40.1075C114.102 57.4325 105.858 59.7632 97.7908 59.7632C90.7899 59.7632 81.4848 57.7273 81.4848 40.1075V0H59.6767V12.069H66.1839V40.1075C66.1839 61.9527 78.0007 74.9969 97.7934 74.9969C117.882 74.9969 129.405 62.2803 129.405 40.1075V12.069H135.913V0H114.102Z",
    fill: "#C6AC70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLogo);
export default __webpack_public_path__ + "static/media/auth_logo.87b9ecac35ed561aa5833e4eb309c20e.svg";
export { ForwardRef as ReactComponent };